import { render, staticRenderFns } from "./GrowTent.vue?vue&type=template&id=3ff919ff&scoped=true"
import script from "./GrowTent.vue?vue&type=script&lang=ts"
export * from "./GrowTent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff919ff",
  null
  
)

export default component.exports